import { Construction } from 'lucide-react';

export const UnderConstructionOverlay = () => {
  return (
    <div 
      className="fixed inset-0 z-[100] flex items-center justify-center"
      data-testid="under-construction-overlay"
    >
      {/* Blurred background overlay */}
      <div className="absolute inset-0 bg-stone-900/70 backdrop-blur-sm" />
      
      {/* Content */}
      <div className="relative z-10 text-center px-6 max-w-2xl mx-auto">
        <div className="bg-white/95 rounded-3xl p-10 shadow-2xl">
          {/* Animated construction icon */}
          <div className="bg-amber-100 w-24 h-24 rounded-full flex items-center justify-center mx-auto mb-6">
            <Construction className="h-12 w-12 text-amber-500 animate-pulse" />
          </div>
          
          <h1 className="text-4xl md:text-5xl font-bold text-stone-800 mb-4" style={{ fontFamily: 'Dancing Script, cursive' }}>
            Under Construction
          </h1>
          
          <p className="text-lg text-stone-600 mb-6">
            We're building something amazing for families! <br />
            Our website will be ready soon.
          </p>
          
          <div className="bg-amber-50 rounded-2xl p-6 mb-6">
            <p className="text-amber-800 font-medium">
              Sunstone Village - Parenting Community
            </p>
            <p className="text-amber-600 text-sm mt-2">
              Raising emotionally intelligent children together
            </p>
          </div>
          
          <div className="text-stone-500 text-sm">
            <p className="mb-2">For inquiries, please contact:</p>
            <a 
              href="mailto:thayani@sunstone-village.com" 
              className="text-amber-600 hover:text-amber-700 font-medium"
            >
              thayani@sunstone-village.com
            </a>
            <span className="mx-2">|</span>
            <a 
              href="tel:+447952929375" 
              className="text-amber-600 hover:text-amber-700 font-medium"
            >
              +44 7952 929375
            </a>
          </div>
        </div>
        
        {/* Logo at bottom */}
        <div className="mt-8">
          <img 
            src="https://customer-assets.emergentagent.com/job_fbc5f0f1-68c0-4e73-b7ff-fe3cee4c3b4e/artifacts/fdujo04p_FinalLogo_OnlyCircle.png" 
            alt="Sunstone Families" 
            className="w-20 h-20 mx-auto opacity-80"
          />
        </div>
      </div>
    </div>
  );
};

export default UnderConstructionOverlay;
